<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="CompanyInfoTable1" :fields="fields" :title="$t(table_title.title1)"
        :show_query_container="true" :show_toolbar_button="[0, 0, 0, 0, 0]" :show_toolbar_container="true"
        :show_pagination_container="true" :show_date_picker="false" :show_toolbar="false" :show_toolbar_state="false"
        :show_filter="true" :date_picker_label="$t(date_picker_label)" :query_button_label="$t(query_lable)"
        :isBusy="isBusy" @on_query="on_query" @on_cell_button_click="on_cell_button_click" tableref="1d144bcc8c124608920aa2ae33749623">
        <template #query>
          <!-- 工厂名称 -->
          {{ $t("common.company") + $t("common.name") }}：<el-input clearable size="small" style="width: 120px"
            v-model="SEI_EntityShortName">
          </el-input>
        </template>
        <template #toolbar>
          <el-popover placement="right" title="提示" width="200" trigger="hover" content="保存需要勾选选中数据。"
            style="border-color: red;">
            <i slot="reference" class="el-icon-question ml-2" style="font-size:18px;margin-top: 6px;"></i>
          </el-popover>
        </template>
        <!-- <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveData" :label="$t('common.save')"
            class="ml-2">
          </QueryButton>
        </template> -->
      </TableMain>
    </BaseContainer>
    <el-dialog title="邮件通知" :visible.sync="emailVisible" width="40%" :top="'12vh'" :close-on-click-modal="false">
      <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 500px">
        <span v-for="(item, index) in email_dictionary" :key="index">
          <el-col :span="18">
            <el-form-item :label="item.label">
              <el-select size="small" multiple v-model="item.value" placeholder="" filterable clearable class="w-100">
                <el-option v-for="(t, k) in user_and_role" :key="k" :label="t.username" :value="t.username"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="success" @click="SaveData">{{ $t('common.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as CompanyInfoController from "../../controllers/base/CompanyInfoController"
import * as commonController from "../../controllers/commonController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import language from "../../shared/language"
import QueryButton from "../components/base/QueryButton"
import TestQueryPanel from "../components/base/TestQueryPanel"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"

export default {
  name: "CompanyInfo",
  components: {
    BaseContainer,
    TableMain,
    TestQueryPanel,
    QueryButton
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_companyinfo",
      },
      fields: CompanyInfoController.fields.default,
      dataForm: _.cloneDeep(CompanyInfoController.dataForm),
      email_dictionary: _.cloneDeep(commonController.dictionary.email_form),
      rules: CompanyInfoController.rules,
      language: language.CompanyInfo,
      SEI_EntityShortName: "",
      isBusy: false,
      emailVisible: false,
      all_role_list: [],
      user_and_role: [],
      current_company_info: null
    }
  },
  methods: {
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.map(_.filter(_dt, { is_sys: false, is_valid: true }), (t) => {
        return { username: t.code }
      })
      this.user_and_role = _.map(this.$store.state.biz_data.baseData.Users, (t) => { return { username: t.username } })
      this.user_and_role = _.union(this.user_and_role, this.all_role_list)
    },
    //#region 查询
    async on_query(set_data, isLoading = true) {
      if (isLoading) {
        this.isBusy = true
        set_data([])
      }
      let _this = this
      let _params = {
        SEI_EntityShortName: { like: "%" + this.SEI_EntityShortName + "%" },
      }
      ///配置api code
      let _result = await CompanyInfoController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        _.each(_result[0], (t) => {
          let _cut_m = _.find(_this.$store.state.biz_data.baseData.Customer, {
            AccountNum: t.CustAccountNum,
          })
          if (_cut_m) {
            t.CustAccountName = _cut_m.SEI_Name
          }
          let _vend_m = _.find(_this.$store.state.biz_data.baseData.Vender, {
            AccountNum: t.VenderAccountNum,
          })
          if (_vend_m) {
            t.VenderAccountName = _vend_m.SEI_Name
          }
          if (t.EmailNotifier)
            t.EmailNotifier = _.split(t.EmailNotifier, ",")
          else
            t.EmailNotifier = []
        })
        set_data(_.orderBy(_result[0], ["modifiedDateTime"], ["desc"]))
      }
      this.isBusy = false
    },
    //#endregion

    //#region 保存
    //保存供应商邮件通知人
    async SaveData() {
      let dt = _.cloneDeep(this.email_dictionary)
      let save_items = []
      save_items.push({
        id: this.current_company_info.id,
        EmailNotifierJson: JSON.stringify(dt),
      })

      let _result = await CompanyInfoController.methods.saveData(save_items)
      if (_result) {
        await this.on_query(this.$refs.CompanyInfoTable1.SetData, false)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        this.emailVisible = false
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
      }
    },
    //#endregion
    async on_cell_button_click(data) {
      this.current_company_info = data.item
      if (data.field.key == "EmailNotifierJson") {
        await this.getAllRoles()
        this.email_dictionary = _.cloneDeep(commonController.dictionary.email_form)
        if (data.item.EmailNotifierJson && data.item.EmailNotifierJson != "") {
          _.each(this.email_dictionary, (t) => {
            let item = _.find(JSON.parse(data.item.EmailNotifierJson), (o) => t.key === o.key)
            if (item) t.value = item.value
          })
        }
        this.emailVisible = true
      }
    },
  },
}
</script>
<style>
.hb_table_cominfo_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 190rem;
}
</style>
